import { useRef } from 'react'

import { useLazyQuery } from '@apollo/client'
import { Menu } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import Tag from 'src/components/DataDisplay/Tag/Tag'
import { TASK_MENU_CLASSNAMES } from 'src/components/Shared/TaskMenus/taskMenuStyles'
import {
  GET_TASK_TEMPLATE,
  GET_TASK_TEMPLATES,
} from 'src/graphql/taskTemplates.graphql'
import IconClipboardList from 'src/icons/IconClipboardList'

// Lets the user prefill the modal from an existing task template. Lists
// templates; on select, fetches the full template and hands it to `onApply`.
const TaskTemplatePicker = ({ onApply }) => {
  const { data } = useQuery(GET_TASK_TEMPLATES, {
    variables: {
      pageInfo: { limit: 100, offset: 0 },
      orderBy: { field: 'title', direction: 'asc' },
    },
  })

  const templates = data?.taskTemplates?.items ?? []

  // Track the most recently clicked template so an earlier, slower fetch can't
  // land after a newer pick and overwrite the form with stale data.
  const latestRequestedId = useRef<string | null>(null)

  const [fetchTemplate] = useLazyQuery(GET_TASK_TEMPLATE, {
    fetchPolicy: 'network-only',
    onCompleted: (result) => {
      const template = result?.taskTemplate
      if (template && template.taskTemplateId === latestRequestedId.current) {
        onApply(template)
      }
    },
  })

  const handleSelect = (taskTemplateId: string) => {
    latestRequestedId.current = taskTemplateId
    fetchTemplate({ variables: { taskTemplateId } })
  }

  if (templates.length === 0) return null

  return (
    <Menu
      offset={6}
      width={240}
      position="bottom-start"
      classNames={TASK_MENU_CLASSNAMES}
    >
      <Menu.Target>
        <div>
          <Tag size="xs" clickable showCloseButton={false}>
            <IconClipboardList className="h-3 w-3 fill-none stroke-doubleNickel-brand-500" />
            Use a template
          </Tag>
        </div>
      </Menu.Target>
      <Menu.Dropdown>
        <div className="flex max-h-64 flex-col gap-1 overflow-y-auto">
          {templates.map((template) => (
            <Menu.Item
              key={template.taskTemplateId}
              onClick={() => handleSelect(template.taskTemplateId)}
            >
              {template.title}
            </Menu.Item>
          ))}
        </div>
      </Menu.Dropdown>
    </Menu>
  )
}

export default TaskTemplatePicker
